import React from "react";
import { ArrowRight } from "lucide-react";

const teaserSlots = [
  { mins: 30, tag: "Focus block" },
  { mins: 45, tag: "Skill + drill" },
  { mins: 60, tag: "Full session" },
];

export default function BookingTeaser() {
  return (
    <section
      id="book-private"
      data-testid="booking-teaser-section"
      className="relative bg-[#d4af37] text-black border-y border-[#d4af37]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Left: Headline */}
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] font-bold">
              One-on-One
            </div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.9] mt-3">
              Book a <br />
              Private Session.
            </h2>
            <p className="mt-4 text-black/80 text-sm md:text-base max-w-md">
              Train 1-on-1 with a head coach — 6am to 6:30pm, any weekday.
              Pick your length below, lock it in in under a minute.
            </p>
          </div>

          {/* Right: Slot cards + CTA */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-3 gap-3 md:gap-4">
              {teaserSlots.map((s) => (
                <a
                  key={s.mins}
                  href={`#booking`}
                  data-testid={`teaser-slot-${s.mins}`}
                  className="group bg-black text-white border-2 border-black hover:border-white transition-colors p-4 md:p-5"
                >
                  <div className="font-heading text-3xl md:text-4xl leading-none text-[#d4af37]">
                    {s.mins}
                    <span className="text-base ml-1">min</span>
                  </div>
                  <div className="mt-3 text-xs uppercase tracking-[0.18em] text-white/70">
                    {s.tag}
                  </div>
                </a>
              ))}
            </div>
            <a
              href="#booking"
              data-testid="teaser-cta-book-now"
              className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-black text-[#d4af37] px-6 py-4 text-xs font-bold uppercase tracking-[0.25em] hover:bg-white hover:text-black transition-colors"
            >
              Book Now
              <ArrowRight size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
